<div class="contact">
    <div class="left-container">
        <p>Email:</p><br>
        <p>Instagram:</p>
    </div>
    <div class="right-container">
        <p>annaladdphoto@gmail.com</p><br>
        <a href="https://instagram.com/LiveLaddLove" target="none">@liveladdlove</a>
    </div>
</div>